import tokensCss from '../../../theme/generated/tokens.css?inline';
import stylesCss from './styles.css?inline';

const MERKE = 'data-innspel-style';

/**
 * Injects tokens.css and the package's stylesheet into `<head>` once. Hosts with a
 * `style-src` without `'unsafe-inline'` import the CSS themselves instead and set
 * `injectStyles: false`. The tokens are GENERATED from theme/theme.ts (M0.4) — this
 * is the one legal route to a colour (CLAUDE.md, «Styling»).
 */
export function ensureStyles(doc: Document = document): void {
  if (doc.head.querySelector(`style[${MERKE}]`)) return;
  const s = doc.createElement('style');
  s.setAttribute(MERKE, '');
  s.textContent = `${tokensCss}\n${stylesCss}`;
  doc.head.appendChild(s);
}

/** The stylesheet as text, for hosts that want to inject it themselves. */
export const css = `${tokensCss}\n${stylesCss}`;
